import { FindSizesFilterOptionsOutput } from '../../../services/modules/filterOptions/filterOptions.types';
import { ProductDetailsSize } from '../../../services/modules/productDetails/productDetails.types';
import { ProductSize } from '../../products/ProductTypes';
import { OfflineDatabaseSize } from '../database/offlineDatabase/types/offlineDatabaseSize.types';

export class OfflineSizeTransformers {
  static toProductSize(offlineSize: OfflineDatabaseSize): ProductSize {
    return {
      active: true,
      id: offlineSize.id,
      name: offlineSize.name,
      unique: offlineSize.unique,
      position: offlineSize.position,
    };
  }

  static toFilterOptionsSize(data: OfflineDatabaseSize): FindSizesFilterOptionsOutput['data'][0] {
    return {
      id: data.id,
      name: data.name,
    };
  }

  static toProductDetailsSize(offlineSize: OfflineDatabaseSize): ProductDetailsSize {
    return {
      id: offlineSize.id,
      name: offlineSize.name,
      productSizeActive: true,
      unique: offlineSize.unique,
      position: offlineSize.position.toString(),
    };
  }
}
